import React, { useState, useContext } from 'react';
import { FiCheck, FiInfo } from 'react-icons/fi';
import { useIntl } from 'react-intl';
import { useStateFromProp } from '~hooks/common';

import Modal from '~components/modal';
import Button from '~components/button';

import { PWAContext } from '~contexts/pwa';

import './style.scss';

const InfoModal = ({ isOpened, onToggle = () => {} }) => {
  const intl = useIntl();
  const [isModalOpened, setModalOpen] = useStateFromProp(isOpened, onToggle);
  const isIOS = navigator.userAgent.match(/iPhone|iPad|iPod/i);

  return (
    <Modal.Wrapper isOpened={isModalOpened} onClose={() => setModalOpen()} className="c-modal--plain c-modal--narrow">
      <Modal.Content>
        <h2 className="l-headline--secondary c-modal__headline">
          {isIOS
            ? intl.formatMessage({
                id: 'containers.contact-options.pwa.modal.headline-ios',
                defaultMessage: 'Install app on your iPhone.',
              })
            : intl.formatMessage({
                id: 'containers.contact-options.pwa.modal.headline',
                defaultMessage: 'Standalone PWA app installation not supported',
              })}
        </h2>
        <p>
          {isIOS
            ? intl.formatMessage({
                id: 'containers.contact-options.pwa.modal.content-ios',
                defaultMessage: 'Tap the install icon on the bottom bar of your browser and then Add to homescreen.',
              })
            : intl.formatMessage({
                id: 'containers.contact-options.pwa.modal.headline',
                defaultMessage: 'Standalone PWA app installation not supported',
              })}
        </p>
      </Modal.Content>
    </Modal.Wrapper>
  );
};

const PWA = () => {
  const intl = useIntl();

  const { isStandalone, promptInstall, isInstallPromptSupported, isInstalled } = useContext(PWAContext);
  const [isInfoModalOpened, setIsInfoModalOpened] = useState(false);

  const handleStandaloneApp = async () => {
    const didInstall = await promptInstall();
    if (didInstall) {
      console.log('PWA installed');
      // User accepted PWA install
    }
  };

  return (
    <div className="c-group c-group--centered">
      <div className="c-group__label">
        {intl.formatMessage({ id: 'containers.contact-options.pwa.standalone-app', defaultMessage: 'Standalone app' })}
      </div>
      <div className="c-group__value c-pwa-install__value">
        {isStandalone || isInstalled ? (
          <span className="c-contact-options__success">
            <FiCheck />
          </span>
        ) : (
          <>
            <Button disabled={!isInstallPromptSupported} className="c-btn--text" onClick={handleStandaloneApp}>
              {intl.formatMessage({ id: 'containers.contact-options.pwa.install', defaultMessage: 'Install' })}
            </Button>
            {!isInstallPromptSupported && (
              <>
                <Button className="c-btn--text" onClick={() => setIsInfoModalOpened(true)}>
                  <FiInfo className="c-pwa-install__info" />
                </Button>
                <InfoModal isOpened={isInfoModalOpened} onToggle={setIsInfoModalOpened} />
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PWA;
